export enum AccountingEventSystemType {
NonSystemic,
PaymentOrderPayment,
PayrollIssue,
PayrollAdvance,
AssetAcquisition,
AssetSale,
AssetDestruction,
AssetDepreciation,
AssetImprovment,
AssetLoss,
AssetProfit,
AssetDepreciationInvoice,
MoneyTransactionDepositToAcount,
MoneyTransactionWithdrawFromAcount,
MoneyTransactionTransferBetweenAccounts,
MoneyTransactionPaymentWithCheck,
MoneyTransactionPaymentWithBank,
MoneyTransactionPaymentWithCash,
MoneyTransactionReceiptWithCheck,
MoneyTransactionReceiptWithBank,
MoneyTransactionReceiptWithCash,
SettlementPaymentOrderPayment,
CheckIssue,
CheckCollect,
CheckDeliver,
BudgetApproval,
IncomeReceiptPayment,
}
